import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import IconButton from '@mui/material/IconButton'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import {Delete, Replay, Phone, Mail} from '@mui/icons-material'
import {injectIntl} from 'react-intl'
// import ReactTelInput from 'react-telephone-input'
import {PhoneInput} from '@framelink/phone_input'
import {createSender, deleteSender, verifySender} from 'modules/applications/actions'
import {getSenders, getTimeout, getCountry} from 'utils/utils'
import Dialog from 'components/Dialog'
import Confirmation from 'components/Confirmation'
import flags from 'images/flags.png'

const Wrapper = styled.span`
    display: inline-flex;
    vertical-align: middle;
`

const List = styled.div`
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
`

const PhoneField = styled.div`
    position: relative;
    height: 45px;
    display: flex;
    flex-direction: column;

    &:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    }

    :hover {
        &:before {
            border-bottom: 2px solid #4a4a4a;
        }
    }
`

const Label = styled.div`
    color: rgba(0, 0, 0, 0.54);
    font-size: 12px;
`

const Icon = styled.div`
    display: flex;
    width: 50px;
`

const Row = styled.div`
    display: flex;
    background: #FFF;
    padding: 15px;
    border-bottom: 1px solid #E1ECEF;
    align-items: center;
    height: 20px;
`

const Name = styled.div`
    width: 50%;
    display: flex;
`

const Actions = styled.div`
    margin-left: auto;
`

const Chip = styled.div`
    border-radius: 15px;
    color: #FFF;
    background: ${props => props.status ? 'rgba(76, 174, 76, 0.8)' : 'rgba(212, 91, 74, 0.8)'};
    font-size: 13px;
    padding: 5px 7px;
`

const types = {
    email: {
        name: 'email'
    },
    sms: {
        name: 'sms'
    }
}

const REQUEST_COUNT = 5

class Verification extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            type: types.email.name,
            email: '',
            sms: '',
            time: Date.now(),
            open: false,
            delete: null
        }

    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleCreate = () => {
        this.props.createSender(this.state[this.state.type], this.state.type)
        this.handleClose()
    }

    handleOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false,
            email: '',
            sms: '',
            delete: null
        })
    }

    handleChangePhone = (value) => {
        this.setState({ sms: '+' + value.replace(/\D/g, '') })
    }

    deleteSender = (id) => {
        this.setState({
            delete: id
        })
    }

    handleDelete = () => {
        this.props.deleteSender(this.state.delete)
        this.handleClose()
    }

    render() {
        const {intl} = this.props
        const senders = getSenders()
        const country = getCountry()

        return (
            <div>
                <Typography variant="subtitle1">
                    {intl.formatMessage({id: "settings.verification_description"})}
                </Typography>
                <Button
                    onClick={this.handleOpen}
                    style={{background: '#4cae4c', color: '#FFF', margin: '20px 0 35px 0'}}
                >
                    {intl.formatMessage({id: "settings.add_sender"})}
                </Button>
                {!!senders && !!senders.length &&
                    <List>
                        {senders.map(item =>
                            <Row key={item.id}>
                                <Icon>
                                    {item.service === types.email.name ?
                                        <Mail /> :
                                        <Phone />
                                    }
                                </Icon>
                                <Name>{item.address}</Name>
                                <Chip status={item.verified}>
                                    {item.verified ?
                                        intl.formatMessage({id: "settings.verified"}) :
                                        intl.formatMessage({id: "settings.unverified"})
                                    }
                                </Chip>
                                <Actions>
                                    <Tooltip
                                        title={intl.formatMessage({id: "settings.request_authorization"})}
                                        placement="top"
                                    >
                                        <Wrapper>
                                            <IconButton
                                                disabled={
                                                    item.latestRequest + getTimeout() > this.state.time ||
                                                    item.requestCount === REQUEST_COUNT ||
                                                    item.verified
                                                }
                                                onClick={() => this.props.verifySender(item.id)}
                                            >
                                                <Replay />
                                            </IconButton>
                                        </Wrapper>
                                    </Tooltip>
                                    <Tooltip
                                        title={intl.formatMessage({id: "settings.delete_sender"})}
                                        placement="top"
                                    >
                                        <Wrapper>
                                            <IconButton
                                                disabled={item.latestRequest + getTimeout() > this.state.time}
                                                onClick={() => this.deleteSender(item.id)}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </Wrapper>
                                    </Tooltip>
                                </Actions>
                            </Row>
                        )}
                    </List>
                }
                <Dialog
                    open={this.state.open || !!this.state.delete}
                    onClose={this.handleClose}
                >
                    {this.state.delete ?
                        <Confirmation
                            text={intl.formatMessage({id: "settings.confirm_delete_text"})}
                            handleClose={this.handleClose}
                            handleConfirm={this.handleDelete}
                        />
                        :
                        <React.Fragment>
                            <DialogTitle>
                                {intl.formatMessage({id: "settings.create_sender"})}
                            </DialogTitle>
                            <DialogContent>
                                <Select
                                    value={this.state.type}
                                    onChange={this.handleChange}
									variant="standard"
                                    inputProps={{
                                        name: 'type'
                                    }}
									sx={{
										width: '100%',
										marginBottom: '30px'
									}}
                                >
                                    {Object.values(types).map(item =>
                                        <MenuItem key={item.name} value={item.name}>
                                            {intl.formatMessage({id: `settings.${item.name}`})}
                                        </MenuItem>
                                    )}
                                </Select>
                                {this.state.type === types.email.name ?
                                    <TextField variant="standard"
                                        sx={{width: '100%'}}
                                        value={this.state.email}
                                        onChange={this.handleChange}
                                        label={intl.formatMessage({id: "settings.enter_email"})}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        inputProps={{
                                            name: 'email'
                                        }}
                                    /> :
                                    <PhoneField>
                                        <Label>
                                            {intl.formatMessage({id: "settings.enter_phone"})}
                                        </Label>
                                        <PhoneInput
                                            defaultCountry={country}
                                            flagsImagePath={flags}
                                            classNames='phoneSender'
                                            onChange={this.handleChangePhone}
                                            value={this.state.sms}
                                        />
                                        <div/>
                                    </PhoneField>
                                }
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleClose} color="primary">
                                    {intl.formatMessage({id: "app.confirm_cancel"})}
                                </Button>
                                <Button variant="contained"
                                    disabled={!this.state[this.state.type].replace(/\s/g, '') ||
                                        !!senders.find(item => item.address === this.state[this.state.type])}
                                    onClick={this.handleCreate}
                                    color="primary"
                                >
                                    {intl.formatMessage({id: "app.confirm_create"})}
                                </Button>
                            </DialogActions>
                        </React.Fragment>
                    }
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = ({applications}) => ({
    current: applications.current,
    isLoading: applications.isLoading
})

export default connect(mapStateToProps, {
    createSender,
    deleteSender,
    verifySender
})(injectIntl(Verification))
